// extracted by mini-css-extract-plugin
module.exports = {"footerMenus__menu":"c7_sn","footerMenus__menu_isNoMargin":"c7_sp"};